import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-add-button',
  standalone: true,
  imports: [],
  templateUrl: './add-button.component.html',
  styleUrl: './add-button.component.css',
})
export class AddButtonComponent {
  label = input.required<string>();
  icon = input<string>('/add.svg');
  clicked = output<void>();
}
